/* eslint-disable react/prop-types */
import React from 'react';
import { sendAnalyticEvent } from './analytics';

const SendValuesToAnalytics = (props) => {
    const {
        pages,
        selectedTopic,
        selectedContactPage,
        contactLabel,
        contactType,
        cardTitle,
        openingHoursText,
        buttonLabel,
        component,
    } = props;

    const topic = pages.topics.find(({ id }) => id === selectedTopic);
    const subtopic = topic?.topics.find(({ id }) => id === selectedContactPage);
    const action = subtopic.topicHeadline;
    let category;
    let label;
    if (action) {
        if (component === 'Button' && contactLabel) {
            category = `CSP-3-${contactLabel}`;
            label = contactType;
        }
        if (component === 'ViewOpeningHours') {
            category = `CSP-4-${openingHoursText}`;
            label = cardTitle;
        }
        if (component === 'Recommended' && buttonLabel) {
            category = `CSP-5-${buttonLabel}`;
            label = 'Recommended';
        }

        sendAnalyticEvent({ action, category, label });
    }

    return <></>;
};

export default SendValuesToAnalytics;
